export function getCheckoutSessionFromStorage(id) {
    try {
        if (!id) {
            return null
        }

        let storedSessionRecord = localStorage.getItem(id)
        if (!storedSessionRecord) {
            return null
        }
    
        let storedSession = JSON.parse(storedSessionRecord)
        return storedSession

    } catch (error) {
        return null
    }
}